module.exports = __webpack_public_path__ + "img/404.5bbf0ca1.png";